<div class="login-form">
  <form #loginForm="ngForm">
    <!-- EMAIL ADDRESS -->
    <div class="form-group">
      <input type="text" class="form-control" [placeholder]="'login.usernamePlaceholder' | transloco" name="username" id="username"
        [(ngModel)]="user.username" required #username="ngModel" />

      @if (username.invalid && (username.dirty || username.touched || formSubmitted)) {
        <span class="error-note">{{ 'login.usernameRequired' | transloco }}</span>
      }
    </div>
    <!-- PASSWORD -->
    <div class="form-group">
      <!-- add form-group--error modifier if there is an error message -->
      <div class="form-group__input-group">
        <input [type]="!showUserPassword ? 'password' : 'text'" class="form-control" [placeholder]="'login.passwordPlaceholder' | transloco"
          name="password" id="password" [(ngModel)]="user.password" required #password="ngModel" />

        <button (click)="showPassword()" class="btn btn--no-spacing" type="button">
          @if (showUserPassword) {
            <!-- show password icon -->
            <svg xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink"
              class="btn__icon btn__icon--svg" version="1.1" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"
              x="0px" y="0px">
              <use xlink:href="assets/icons/icon-show-password.svg#icon-show-password"></use>
            </svg>
          } @else {
            <!-- hide password icon -->
            <svg xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink"
              class="btn__icon btn__icon--svg" version="1.1" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"
              x="0px" y="0px">
              <use xlink:href="assets/icons/icon-hide-password.svg#icon-hide-password"></use>
            </svg>
          }
        </button>
      </div>
      @if (password.invalid && (password.dirty || password.touched || formSubmitted)) {
        <span class="error-note">{{ 'login.passwordRequired' | transloco }}<br /></span>
      }
      @if (inlineErrorMessage) {
        <span class="error-note">{{ inlineErrorMessage }}</span>
      }
    </div>

    <div class="form-group form-group--options mb-5">
      <div class="form-check">
        <input class="form-check-input clickable" type="checkbox" value="" id="flexCheckDefault" />
        <label class="form-check-label" for="flexCheckDefault">
          {{ 'login.rememberMe' | transloco }}
        </label>
      </div>

      <a (click)="toggleForgotPassword()" class="clickable">{{ 'login.forgotPassword' | transloco }}</a>
    </div>
    <!-- LOGIN BUTTON -->
    <div class="form-group">
      <button type="submit" class="btn btn-primary btn-big btn-block" (click)="login()">
        {{ 'login.logIn' | transloco }}
      </button>
    </div>
  </form>
</div>